import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Image from 'components/AppImage';

const ServiceCard = ({ service }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const formatPrice = (colones, dollars) => {
    return `₡${colones.toLocaleString()} / $${dollars}`;
  };

  const getFrequencyLabel = (frequency) => {
    const labels = {
      'weekly': 'Semanal',
      'bi-weekly': 'Quincenal',
      'one-time': 'Una vez',
      'seasonal': 'Estacional',
      'emergency': 'Emergencia',
      'as-needed': 'Según necesidad'
    };
    return labels[frequency] || frequency;
  };

  const getCategoryColor = (category) => {
    const colors = {
      'maintenance': 'bg-primary/10 text-primary',
      'deep-cleaning': 'bg-accent/10 text-accent',
      'repair': 'bg-warning/10 text-warning',
      'seasonal': 'bg-success/10 text-success',
      'emergency': 'bg-error/10 text-error'
    };
    return colors[category] || 'bg-secondary/10 text-secondary';
  };

  return (
    <div className="bg-surface rounded-lg shadow-medium hover:shadow-large nav-transition overflow-hidden">
      {/* Service Image */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover"
        />
        {service.popular && (
          <div className="absolute top-4 left-4 bg-accent text-white px-3 py-1 rounded-full text-sm font-medium">
            Más Popular
          </div>
        )}
        <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-sm font-medium ${getCategoryColor(service.category)}`}>
          {getFrequencyLabel(service.frequency)}
        </div>
      </div>

      {/* Service Content */}
      <div className="p-6">
        <h3 className="text-xl font-heading font-semibold text-text-primary mb-2">
          {service.title}
        </h3>
        
        <p className="text-text-secondary mb-4 line-clamp-3">
          {service.description}
        </p>

        {/* Service Details */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary flex items-center space-x-2">
              <Icon name="Clock" size={16} />
              <span>Duración:</span>
            </span>
            <span className="font-medium text-text-primary">{service.duration}</span>
          </div>
          
          <div className="flex items-center justify-between text-sm">
            <span className="text-text-secondary flex items-center space-x-2">
              <Icon name="DollarSign" size={16} />
              <span>Precio:</span>
            </span>
            <span className="font-medium text-text-primary">
              {formatPrice(service.priceColones, service.priceDollars)}
            </span>
          </div>
        </div>

        {/* Features Toggle */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between text-primary hover:text-primary/80 nav-transition mb-4"
        >
          <span className="font-medium">
            {isExpanded ? 'Ocultar detalles' : 'Ver detalles incluidos'}
          </span>
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={20} />
        </button>

        {/* Expandable Features */}
        {isExpanded && (
          <div className="mb-6 p-4 bg-background rounded-lg">
            <h4 className="font-medium text-text-primary mb-3">Incluye:</h4>
            <ul className="space-y-2">
              {service.features.map((feature, index) => (
                <li key={index} className="flex items-start space-x-2 text-sm text-text-secondary">
                  <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/contact-quote-request"
            state={{ selectedService: service.title }}
            className="flex-1 bg-primary text-white px-4 py-3 rounded-lg font-medium hover:bg-primary/90 nav-transition text-center inline-flex items-center justify-center space-x-2"
          >
            <Icon name="MessageSquare" size={18} />
            <span>Solicitar Cotización</span>
          </Link>
          
          <button
            onClick={() => {
              const message = encodeURIComponent(`Hola, me interesa el servicio de ${service.title}. ¿Podrían darme más información?`);
              window.open(`https://wa.me/50688888888?text=${message}`, '_blank');
            }}
            className="flex-1 bg-success text-white px-4 py-3 rounded-lg font-medium hover:bg-success/90 nav-transition inline-flex items-center justify-center space-x-2"
          >
            <Icon name="MessageCircle" size={18} />
            <span>WhatsApp</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;